import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ChecksTable from 'dashboard/components/ChecksTable';
import { VerificationDetailProps } from 'dashboard/components/VerificationDetail/types';
import { formatAddressFieldDisplay, formatDate } from 'dashboard/lib/utils/formatters';
import { VerificationDatabasePhoneCarrier } from 'dashboard/models/verification';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { COUNTRIES } from 'lib/constants/locales';

const StyledAttributeGrid = styled(AttributeGrid)`
  padding: 0 ${Spacing[4]} ${Spacing[2]};
`;

const ChecksInformationRow = styled('div')`
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: ${Spacing[4]};
`;

interface DatabasePhoneCarrierVerificationProps extends VerificationDetailProps {
  verification: VerificationDatabasePhoneCarrier;
}

const DatabasePhoneCarrierVerification = ({
  verification,
}: DatabasePhoneCarrierVerificationProps) => {
  const {
    'phone-number': phoneNumber,
    'country-code': countryCode,
    'name-first': nameFirst,
    'name-last': nameLast,
    'address-street-1': addressStreet1,
    'address-street-2': addressStreet2,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
    'address-postal-code': addressPostalCode,
    birthdate,
    'redacted-at': redactedAt,
  } = verification.attributes;

  const redacted = redactedAt != null;
  const checks = verification.attributes.checks;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const showChecks = checks.length > 0;

  const address = formatAddressFieldDisplay({
    addressStreet1: addressStreet1,
    addressStreet2: addressStreet2,
    addressCity: addressCity,
    addressSubdivision: addressSubdivision,
    addressPostalCode: addressPostalCode,
  });

  return (
    <ChecksInformationRow data-test='verification-detail__database-phone-carrier-verification'>
      <StyledAttributeGrid>
        <Attribute
          label='Phone number'
          value={phoneNumber}
          redacted={redacted}
          data-test='verification-detail__database-phone-carrier-phone-number'
        />
        <Attribute
          label='Country'
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          value={COUNTRIES[countryCode]}
          redacted={redacted}
          data-test='verification-detail__database-phone-carrier-phone-number'
        />
        {!showChecks && (
          <>
            <Attribute
              label='Address'
              value={address}
              redacted={redacted}
              data-test='verification-detail__database-phone-carrier-address'
            />
            <Attribute
              label='First Name'
              value={nameFirst}
              redacted={redacted}
              data-test='verification-detail__database-phone-carrier-first-name'
            />
            <Attribute
              label='Last Name'
              value={nameLast}
              redacted={redacted}
              data-test='verification-detail__database-phone-carrier-last-name'
            />
            <Attribute
              label='Birthdate'
              value={formatDate(birthdate)}
              redacted={redacted}
              data-test='verification-detail__database-phone-carrier-birthdate'
            />
          </>
        )}
      </StyledAttributeGrid>
      {checks && showChecks && <ChecksTable checks={checks} verification={verification} />}
    </ChecksInformationRow>
  );
};

export default DatabasePhoneCarrierVerification;
